const URL = '/reportes_actuales';

const state = {
  edited: {
    deuda_usuario: null,
    deuda_usuario_30: null,
    deuda_usuario_90: null,
    deuda_usuario_mas_90: null,
    subsidio_sin_utilizar: null,
    subsidio_sin_utilizar_30: null,
    subsidio_sin_utilizar_90: null,
    subsidio_sin_utilizar_mas_90: null,
    deuda_sin_subsidio: null,
    deuda_sin_subsidio_30: null,
    deuda_sin_subsidio_90: null,
    deuda_sin_subsidio_mas_90: null,
  },
  loading: false,
}

// GETTERS
const getters = {
  edited(state) {
    return state.edited
  },
  loading(state) {
    return state.loading
  },
}

// ACTIONS
const actions = {
  onClearEdited({ commit }) {
    commit('setEdited', {
      deuda_usuario: null,
      deuda_usuario_30: null,
      deuda_usuario_90: null,
      deuda_usuario_mas_90: null,
      subsidio_sin_utilizar: null,
      subsidio_sin_utilizar_30: null,
      subsidio_sin_utilizar_90: null,
      subsidio_sin_utilizar_mas_90: null,
      deuda_sin_subsidio: null,
      deuda_sin_subsidio_30: null,
      deuda_sin_subsidio_90: null,
      deuda_sin_subsidio_mas_90: null,
    })
  },
  onFetch({ state, commit }) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      axios.get(URL)
        .then(response => {
          commit('setEdited', response.data)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
        .finally(() => {
          commit('setLoading', false)
        })
    })
  }
}

// MUTATIONS
const mutations = {
  setEdited(state, payload) {
    state.edited = Object.assign({}, payload)
  },
  setLoading(state, payload) {
    state.loading = payload
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
